import React, {PureComponent} from 'react';
import {Alert, Button, Form, Spinner, FormGroup, Label, Input, FormFeedback} from "reactstrap";
import {Formik} from "formik";
import * as yup from "yup";
import {requiredMessage} from "../../utils/form-validation";
import {IPaymentEditFormRequest, IPayment} from '../../models/Payment';
import {sanitizeForm} from "../../utils/sanitize-form";
import NumberFormat from "react-number-format";
import Dropdown from "../UI/Dropdown";
import DateTimePicker from "../UI/DateTimePicker";
import {paymentOptions} from "../../utils/payments";
import {dateConvert} from "../../utils/date-convert";



const schema = yup.object({
    methodId: yup.number().nullable().required(requiredMessage()),
    amount: yup.number().min(1, requiredMessage()).required(requiredMessage()),
    payedAt: yup.string().required(requiredMessage()),
    comment: yup.string()
});

type PaymentEditType = {
    editPaymentForm: (id:number, form: IPaymentEditFormRequest) => void
    changeLoading: boolean
    changeError: string
    cancelHandler?: () => void
    data:IPayment
}

class PaymentEdit extends PureComponent<PaymentEditType> {
    render() {
        const {editPaymentForm, changeLoading, changeError, cancelHandler, data} = this.props;
            return (
            <Formik
                validationSchema={schema}
                onSubmit={(values) => {
                    const methodId = sanitizeForm(values.methodId);
                    const amount = sanitizeForm(values.amount);
                    const payedAt = sanitizeForm(values.payedAt);
                    const comment = sanitizeForm(values.comment);

                    const form = {
                        methodId,
                        amount,
                        payedAt: dateConvert(payedAt, 'dd-MM-yyyy', 'yyyy-MM-dd'),
                        comment
                    };

                    editPaymentForm(data.id, form)
                }}
                initialValues={{
                    methodId: data.methodId || null,
                    amount: data.amount || 0,
                    payedAt: data.payedAt ?
                        dateConvert(data.payedAt, 'yyyy-MM-dd', 'dd-MM-yyyy')
                        : null,
                    comment: data.comment || ''
                }}
            >
                {({
                      dirty,
                      handleSubmit,
                      handleChange,
                      values,
                      touched,
                      errors,
                      setFieldValue
                  }) => (
                    <Form onSubmit={handleSubmit}>
                        <FormGroup>
                            <Label>Метод оплаты <span className={'required'}>*</span></Label>
                            <Dropdown
                                name={'methodId'}
                                value={values.methodId}
                                options={paymentOptions}
                                onChange={(value) => setFieldValue('methodId', value)}
                                invalid={touched.methodId && !!errors.methodId}
                            />
                            <FormFeedback>{errors.methodId}</FormFeedback>
                        </FormGroup>
                        <FormGroup>
                            <Label>Сумма <span className={'required'}>*</span></Label>
                            <NumberFormat
                                name={'amount'}
                                allowNegative={false}
                                decimalSeparator={false}
                                value={values.amount}
                                onValueChange={({floatValue}) => setFieldValue('amount', floatValue)}
                                invalid={touched.amount && !!errors.amount}
                                customInput={Input}
                            />
                            <FormFeedback>{errors.amount}</FormFeedback>
                        </FormGroup>
                        <FormGroup>
                            <Label>Дата <span className={'required'}>*</span></Label>
                            <DateTimePicker
                                name={'payedAt'}
                                value={values.payedAt}
                                onChange={payedAt => setFieldValue('payedAt', payedAt)}
                                invalid={touched.payedAt && !!errors.payedAt}
                            />
                            <FormFeedback>{errors.payedAt}</FormFeedback>
                        </FormGroup>
                        <FormGroup>
                            <Label>Комментарий</Label>
                            <Input
                                tag="textarea"
                                type="text"
                                name="comment"
                                value={values.comment}
                                onChange={handleChange}
                                invalid={touched.comment && !!errors.comment}
                            />
                            <FormFeedback>{errors.comment}</FormFeedback>
                        </FormGroup>
                        {changeError &&
                        (<Alert className={'mt-3'} color={'danger'}>
                            {changeError}
                        </Alert>)}
                        <div className={'text-right'}>
                            {cancelHandler &&
                            <Button color="light" onClick={cancelHandler} className={'mr-3'}>Отменить</Button>}
                            <Button type="submit" color={'success'} disabled={changeLoading || !dirty}>
                                {changeLoading &&
                                (<Spinner
                                    size="sm"
                                />)}
                                Сохранить
                            </Button>
                        </div>
                    </Form>
                )}
            </Formik>
        )
    }
}

export default PaymentEdit;
